/*
this snippet listens to the recommended product event which is thrown after an addtocart
- we grab the saved utms from the local storage
- and write them into the order attributes via cart/update
*/

window.addEventListener("recommendedProducts", function (e) {
  let notesAlreadyUpdated = sessionStorage.getItem("attributesUpdated");

  // it was already set, we do nothing
  if (notesAlreadyUpdated) {
    return;
  }

  // it wasn't set yet, we update the sessionStorage and update the attributes
  // get the utms
  const utmParams = localStorage.getItem("utm-params");
  let attributes = {};
  if (utmParams) {
    try {
      attributes = JSON.parse(utmParams);
    } catch (e) {
      //console.error("Fehler beim Parsen der UTM-Parameter:", e);
      attributes = {};
    }

    // Fetch zu /cart/update.js
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes }),
    })
      .then((response) => {
        if (response.ok) {
          //console.log("UTM-Parameter erfolgreich in cart attributes gespeichert");
          sessionStorage.setItem("attributesUpdated", "true");
        } else {
          console.error(
            "Fehler beim Speichern der cart attributes:",
            response.statusText,
          );
        }
      })
      .catch((error) => {
        //console.error("Netzwerkfehler beim cart update:", error);
      });
  } else {
    //console.log("keine utms gefunden");
  }
});

//this script listens to the viewed_product which is thrown from product-history.liquid
//the event is only thrown if there's an item in the cart after that, each time the viewed_product event is
//thrown for each new product that's visited
window.addEventListener("viewed_product", function () {
  let viewedProducts = localStorage.getItem("viewedProducts");

  if (viewedProducts) {
    let viewedProductsAttribute = {
      viewed_products: viewedProducts,
    };
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: viewedProductsAttribute }),
    })
      .then((response) => {
        if (!response.ok) {
          // Fehler beim Speichern der cart attributes
          // Custom Event bei Fehler
        }
      })
      .catch((error) => {
        // Netzwerkfehler oder andere Fehler
        // Custom Event bei Netzwerkfehler
      });
  }
});

document.addEventListener("shopPay_test", function () {
  let shopPay_test = "true";

  if (shopPay_test) {
    let shopPay_test_attribute = {
      shopay_test: shopPay_test,
    };
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: shopPay_test_attribute }),
    })
      .then((response) => {
        if (!response.ok) {
          // Fehler beim Speichern der cart attributes
          // Custom Event bei Fehler
        }
      })
      .catch((error) => {
        // Netzwerkfehler oder andere Fehler
        // Custom Event bei Netzwerkfehler
      });
  }
});
